import { MasterConfigs } from "../../interfaces/entity";

const PrimaryConfig: MasterConfigs = {
    api: () => "/users",
    maskClosable: false,
    modalTitle: () => "Edit User",
    getFormColumns: () => [
        {
            label: "First Name",
            name: "firstName",
            type: "text",
            inputProps: { disabled: true }
        },
        {
            label: "Last Name",
            name: "lastName",
            type: "text",
            inputProps: { disabled: true }
        },
        {
            label: "Physically Handicapped",
            name: "physicalChallenges",
            type: "select",
            children: ['Yes', 'No'].map(ele => ({ name: ele, value: ele }))
        },
        {
            label: "Marital Status",
            name: "maritalStatus",
            type: "select",
            children: ['Single', 'Married'].map(ele => ({ name: ele, value: ele }))
        },
        {
            label: "Blood Group",
            name: "bloodGroup",
            type: "select",
            children: ["A+", "A-", "B+", "B-", "AB+", "AB-", "O+", "O-"].map(ele => ({ name: ele, value: ele }))
        },
    ]
}


export default PrimaryConfig;